<div appTheme>
    <div class="modal-box scrolling">
        <div class=" modal-box-container main-container row">
            <h1>Registration Confirmation Sent</h1>
            <div>
                <p>An email has been sent to the provided email address: </p>
                <blockquote>{{email}}</blockquote>
                <p>Follow the instructions in the email to complete your registration.</p>
                <p>Allow a few minutes for the email to reach your inbox. If you can't find the email, you can <a (click)="resendConfirmation($event)">resend
                    it</a>.
                </p>
                <div class="bottom">
                    <button class="submit-button button-small" id="submitBtn" (click)="goToMain($event)">
                        Ok <i class="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
